var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_505_772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0.5H3C1.61929 0.5 0.5 1.61929 0.5 3V48C0.5 49.3807 1.61929 50.5 3 50.5H48C49.3807 50.5 50.5 49.3807 50.5 48V3C50.5 1.61929 49.3807 0.5 48 0.5Z",
    stroke: "#44465F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0312 15.457H38.7812V18.457H11.0312V15.457Z",
    fill: "#44465F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0312 23.6953H38.7812V26.6953H11.0312V23.6953Z",
    fill: "#44465F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0312 31.9316H38.7812V34.9316H11.0312V31.9316Z",
    fill: "#44465F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_505_772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.5eb18e2b8469fa8bd4f5bf622c05e34f.svg";
export { ForwardRef as ReactComponent };